import { render, staticRenderFns } from "./DataCollectionPage.vue?vue&type=template&id=28fdad5c&scoped=true&"
import script from "./DataCollectionPage.vue?vue&type=script&lang=js&"
export * from "./DataCollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./DataCollectionPage.vue?vue&type=style&index=0&id=28fdad5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fdad5c",
  null
  
)

export default component.exports